module.exports = __webpack_public_path__ + "img/list-table-view.fd461773.svg";